const deliveryConfirmationNL = {
    "view": {
        "table": {
            "title": "Geleverde Lijst",
            "columns": {
                "release": "Release",
                "upc": "UPC Nummer",
                "action": "Actie",
                "status": "Status",
                "deliveryDate": "Leverdatum",
                "details": "Details"
            },
            "label": {
                "statusDelivered": "GELEVERD",
                "statusPartially": "GEDEELTELIJK",
                "statusUndelivered": "NIET GELEVERD",
                "ddexActionInsert": "INVOEGEN",
                "ddexActionFullUpdate": "VOLLEDIGE UPDATE",
                "ddexActionMetadataUpdate": "META. UPDATE",
                "ddexActionTakedown": "VERWIJDEREN"
            },
            "placeholder": {
                "search": "Zoeken..."
            },
            "button": {
                "open": "OPENEN",
                "exportCSV": "Exporteer CSV"
            }
        }
    },
    "breakdownView": {
        "table": {
            "title": "Winkel Leveringslijst",
            "column": {
                "store": "Winkel",
                "additionalNote": "Aanvullende Notities",
                "status": "Status"
            },
            "label": {
                "statusDelivered": "GELEVERD",
                "statusUndelivered": "NIET GELEVERD"
            },
            "button": {
                "exportCSV": "Exporteer CSV"
            },
            "message": {
                "appleSubjectToQC": "Succesvol geleverd, onder voorbehoud van extra QC-controle door Apple Music-medewerkers.",
                "releaseDeliverySuccessfull": "Release is succesvol geleverd aan de {{dspName}} servers",
                "releaseDeliveryUnsuccessfull": "Release levering was niet succesvol voor {dspName}.",
                "noDeliveriesPossible": "Momenteel geen leveringen mogelijk"
            }
        }
    }
};

export default deliveryConfirmationNL;